<!-- 编辑 -->
<template>
  <div class="box">
    <!-- 路径 -->
    <div class="path">
      <img class="path_img" src="../../../../../assets/images/path.png"/>
      <div class="path_txt">运营管理系统 > 快应用报表 > 快应用投放 > 批量新增</div>
    </div>
    <!-- 编辑 -->
    <div class="work">
      <!--表单提交-->
      <el-form class="work_form" :model="formData" ref="formData" :rules="formRules" label-position="right" label-width="200px">
        <el-form-item label="应用：" prop="app_id">
          <el-select v-model="formData.app_id" filterable placeholder="请选择应用">
            <el-option
                    v-for="app in apps"
                    :key="parseInt(app.app_id)"
                    :label="'(' + app.app_id + ')' + app.app_name"
                    :value="parseInt(app.app_id)">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="应用类型：" prop="app_type" v-if="formData.app_id && apps && apps.find(item => item.app_id==formData.app_id).business_line == 'quickapp'" required>
          <el-select v-model="formData.app_type" filterable placeholder="请选择应用类型">
            <el-option
                    v-for="key in Object.keys(appTypes)"
                    :key="parseInt(key)"
                    :label="'(' + key + ')' + appTypes[key]"
                    :value="parseInt(key)">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="渠道：" prop="channel_id">
          <el-select v-model="formData.channel_id" filterable placeholder="请选择应用">
            <el-option
                    v-for="item in channels"
                    :key="parseInt(item.channel_id)"
                    :label="'(' + item.channel_id + ')' + item.channel_name"
                    :value="parseInt(item.channel_id)">
            </el-option>
          </el-select>
        </el-form-item>
        

        <el-form-item label="投放内容：" v-if="formData.app_id && apps && apps.find(item => item.app_id==formData.app_id).business_line == 'quickapp'">
          <el-select v-model="formData.measure_id" filterable clearable placeholder="请选择测评问题">
            <el-option
                    v-for="item in appraises"
                    :key="item.appraise_id"
                    :label="'(' + item.appraise_id + ')' + item.appraise_title"
                    :value="item.appraise_id">
            </el-option>
          </el-select>
          <el-tag>测评</el-tag>
          <br />
          <el-select v-model="formData.book_id" filterable clearable placeholder="请选择小说">
            <el-option
                    v-for="item in books"
                    :key="item.book_id"
                    :label="'(' + item.book_id + ')' + item.book_name"
                    :value="item.book_id">
            </el-option>
          </el-select>
          <el-tag>小说</el-tag>
          <br />
          <el-select v-model="formData.shortplay_id" filterable clearable placeholder="请选择短剧">
            <el-option
                    v-for="item in shortplays"
                    :key="item.shortplay_id"
                    :label="'(' + item.shortplay_id + ')' + item.shortplay_name"
                    :value="item.shortplay_id">
            </el-option>
          </el-select>
          <el-tag>短剧</el-tag>
          <br />
          <el-select v-model="formData.cookbook_id" filterable clearable placeholder="请选择菜谱">
            <el-option
                    v-for="key in Object.keys(cookbooks)"
                    :key="parseInt(key)"
                    :label="'(' + key + ')' + cookbooks[key]"
                    :value="parseInt(key)">
            </el-option>
          </el-select>
          <el-tag>菜谱</el-tag>
          <br />
          <el-select v-model="formData.health_class_id" filterable clearable placeholder="请选择养生分类">
            <el-option
                    v-for="key in Object.keys(health_classes)"
                    :key="parseInt(key)"
                    :label="'(' + key + ')' + health_classes[key]"
                    :value="parseInt(key)">
            </el-option>
          </el-select>
          <el-select v-model="formData.health_id" filterable clearable placeholder="请选择养生文章">
            <el-option
                    v-for="key in Object.keys(healthes)"
                    :key="parseInt(key)"
                    :label="'(' + key + ')' + healthes[key]"
                    :value="parseInt(key)">
            </el-option>
          </el-select>
          <el-tag>养生</el-tag>
          <br />
          <el-tag type="danger">请在测评、小说、短剧、菜谱、养生中仅选择其一</el-tag>
        </el-form-item>
        <el-form-item label="投放平台：" prop="issue_platform">
          <el-select v-model="formData.issue_platform" @change="changedIssuePlatforms" filterable placeholder="请选择投放平台">
            <el-option
                    v-for="item in issuePlatforms"
                    :key="item.issue_platform_tag"
                    :label="item.issue_platform_name"
                    :value="item.issue_platform_tag">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="投放流量：" prop="issue_flow">
          <el-select v-model="formData.issue_flow" filterable placeholder="请选择投放流量">
            <el-option
                    v-for="item in issueFlows"
                    :key="item.issue_flow_tag"
                    :label="item.issue_flow_name"
                    :value="item.issue_flow_tag">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="回传类型：" prop="issue_effect_type" v-if="issueEffects && issueEffects.length > 0">
          <el-select v-model="formData.issue_effect_type" @change="changedIssueEffect" filterable clearable placeholder="请选择效果数据回传类型">
            <el-option
                    v-for="item in issueEffects"
                    :key="item.issue_effect_tag"
                    :label="item.issue_effect_name"
                    :value="item.issue_effect_tag">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="应用配置场景：" prop="issue_cfg_scene" v-if="formData.app_id && apps && apps.find(item => item.app_id==formData.app_id).business_line == 'quickapp'">
          <el-select v-model="formData.issue_cfg_scene" filterable clearable placeholder="请选择应用配置场景">
            <el-option
                    v-for="key in Object.keys(issueCfgScenes)"
                    :key="parseInt(key)"
                    :label="issueCfgScenes[key]"
                    :value="parseInt(key)">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="广告场景：" prop="issue_ad_scene" v-if="formData.app_id && apps && apps.find(item => item.app_id==formData.app_id).business_line == 'quickapp'">
          <el-select v-model="formData.issue_ad_scene" filterable clearable placeholder="请选择广告场景">
            <el-option
                    v-for="key in Object.keys(issueAdScenes)"
                    :key="parseInt(key)"
                    :label="issueAdScenes[key]"
                    :value="parseInt(key)">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="打底广告场景：" prop="issue_ad_bidbase" v-if="(formData.issue_ad_scene==null || formData.issue_ad_scene=='') && formData.app_id && apps && apps.find(item => item.app_id==formData.app_id).business_line == 'quickapp'">
          <el-select v-model="formData.issue_ad_bidbase" filterable clearable placeholder="请选择打底广告场景">
            <el-option
                    v-for="key in Object.keys(adResourceBidbases)"
                    :key="parseInt(key)"
                    :label="adResourceBidbases[key]"
                    :value="parseInt(key)">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="投放主体：" prop="issue_company" v-if="formData.issue_platform=='kuaishou'">
          <el-select v-model="formData.issue_company" filterable clearable placeholder="请选择投放主体">
            <el-option
                    v-for="key in Object.keys(issueCompanies)"
                    :key="parseInt(key)"
                    :label="issueCompanies[key]"
                    :value="parseInt(key)">
            </el-option>
          </el-select>
          &nbsp;&nbsp;
          <el-checkbox v-model="formData.is_ko">启用快手OPPO多拉</el-checkbox>
        </el-form-item>
        <el-form-item label="投放主体：" prop="issue_company" v-if="formData.issue_platform=='uc' || formData.issue_platform=='baidu'">
          <el-select v-model="formData.issue_company" filterable clearable placeholder="请选择投放主体">
            <el-option
                    v-for="key in Object.keys(issueUcCompanies)"
                    :key="parseInt(key)"
                    :label="issueUcCompanies[key]"
                    :value="parseInt(key)">
            </el-option>
          </el-select>
          <el-select v-model="formData.issue_domain" filterable clearable placeholder="请选择投放域名">
            <el-option
                    v-for="key in Object.keys(issueUcDomains)"
                    :key="parseInt(key)"
                    :label="issueUcDomains[key]"
                    :value="parseInt(key)">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="投放产品：" prop="issue_product" v-if="formData.issue_platform=='wifi' || formData.issue_platform=='iqiyi' || formData.issue_platform=='kuaishou' || formData.issue_platform=='toutiao' || formData.issue_platform=='uc'">
          <el-select v-model="formData.issue_product" filterable clearable placeholder="请选择投放产品">
            <el-option
                    v-for="key in Object.keys(issueProducts)"
                    :key="parseInt(key)"
                    :label="issueProducts[key]"
                    :value="parseInt(key)">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="落地页背景：" prop="issue_bg_campaign" v-if="formData.issue_platform=='oppo' || formData.issue_platform=='wifi' || formData.issue_platform=='uc' || formData.issue_platform=='kuaishou'">
          <el-select v-model="formData.issue_bg_campaign" filterable clearable placeholder="请选择落地页背景">
            <el-option
                    v-for="key in Object.keys(issueBgCampaigns)"
                    :key="parseInt(key)"
                    :label="issueBgCampaigns[key]"
                    :value="parseInt(key)">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="账号导入：" prop="issue_accounts" required>
          <el-upload
            :action="uploadAppIssueBatchFile(this.formData.channel_id)"
            :on-success="handleUploadSuccess"
            :on-remove="handleUploadRemove"
            with-credentials
            :headers="uploadHeader"
            name="file"
            :multiple="false"
            :limit="1"
            accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            :file-list="uploadFileList">
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
          <el-table
            v-if="formData.issue_accounts.length"
            :data="formData.issue_accounts"
            border
            style="width: 100%">
            <el-table-column prop="channel_slot_id" show-overflow-tooltip label="渠道位置" width="80"></el-table-column>
            <el-table-column prop="issue_account" show-overflow-tooltip label="投放账号" width="140"></el-table-column>
            <el-table-column prop="issue_hap_url" show-overflow-tooltip label="HAP链接"></el-table-column>
            <el-table-column prop="issue_h5_url" show-overflow-tooltip label="H5链接"></el-table-column>
            <el-table-column prop="issue_tv_url" show-overflow-tooltip label="曝光监测链接"></el-table-column>
            <el-table-column prop="issue_tc_url" show-overflow-tooltip label="点击监测链接"></el-table-column>
          </el-table>
        </el-form-item>

        <el-form-item label="回传设置：" prop="appEffect" required>
          <el-button size="small" type="primary" @click="showDialog">点击设置</el-button>
        </el-form-item>
        <el-form-item>
          <el-button class="btn_confirm" type="primary" :disabled="formData.issue_accounts.length == 0" @click="onGenerate">生成链接</el-button>
          <el-button class="btn_confirm" type="primary" :disabled="formData.issue_accounts.length == 0 || hasSavedAppIssue" @click="submitForm('formData')">保存</el-button>
          <el-button class="btn_confirm" type="primary" :disabled="formData.issue_accounts.length == 0" @click="onDownload()">下载</el-button>
          <el-button class="btn_cancel" @click="onBack">返回</el-button>
        </el-form-item>
      </el-form>
    </div>





    <!--效果数据回传设置弹窗-->
    <el-dialog title="效果数据回传设置" 
      :visible.sync="dialogConfigEffectVisible" 
      :close-on-click-modal="false"
      width="950px"
      center>
      <el-form :model="formConfigEffect" ref="formConfigEffect" :rules="configEffectRules">
        <el-form-item label="回传模式：" label-width="100px">
          <el-checkbox-group v-model="effectModeSelected" onchange="configEffectModeChange">
            <el-checkbox-button v-for="mode in effectModes" :label="mode" :key="mode">{{mode}}</el-checkbox-button>
          </el-checkbox-group>
          <el-checkbox-group v-model="effectModeSelected2" onchange="configEffectModeChange">
            <el-checkbox-button v-for="mode in effectModes2" :label="mode" :key="mode">{{mode}}</el-checkbox-button>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="回传比例:" prop="effectRate" label-width="100px">
            <el-input v-model="formConfigEffect.effectRate" clearable autocomplete="off" style="width:200px;"></el-input>&nbsp;%
        </el-form-item>
        <el-form-item label="广告点击:" prop="effectAdClick" label-width="100px">
            <el-input v-model="formConfigEffect.effectAdClick" clearable autocomplete="off" style="width:200px;"></el-input>&nbsp;次
        </el-form-item>
        <el-form-item label="广告曝光:" prop="effectAdView" label-width="100px">
            <el-input v-model="formConfigEffect.effectAdView" clearable autocomplete="off" style="width:200px;"></el-input>&nbsp;
            <el-input v-model="formConfigEffect.effectAdView2" clearable autocomplete="off" style="width:200px;" v-if="effectModeSelected2 && effectModeSelected2.find(item => item=='用户ARPU3')!=undefined"></el-input>&nbsp;次
        </el-form-item>
        <el-form-item label="广告价格:" prop="effectAdPrice" label-width="100px">
            <el-input v-model="formConfigEffect.effectAdPrice" clearable autocomplete="off" style="width:200px;"></el-input>&nbsp;元（eCPM）
        </el-form-item>
        <el-form-item label="用户ARPU:" prop="effectArpu" label-width="100px">
            <el-input v-model="formConfigEffect.effectArpu" clearable autocomplete="off" style="width:200px;"></el-input>&nbsp;
            <el-input v-model="formConfigEffect.effectArpu2" clearable autocomplete="off" style="width:200px;" v-if="effectModeSelected2 && effectModeSelected2.find(item => item=='用户ARPU3')!=undefined"></el-input>&nbsp;元
        </el-form-item>
        <el-form-item label="ROI:" prop="effectRoi" label-width="100px">
            <el-input v-model="formConfigEffect.effectRoi" clearable autocomplete="off" style="width:200px;"></el-input>&nbsp;
        </el-form-item>
        <el-form-item label="忽略设备:" label-width="100px">
            <el-checkbox v-model="effectIgnoreOppo" style="width:100px;">忽略OPPO</el-checkbox>
            <el-checkbox v-model="effectIgnoreVivo" style="width:100px;">忽略VIVO</el-checkbox>
            <el-checkbox v-model="effectUnifySwitch" style="width:100px;">统一回传</el-checkbox>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="onCancelConfigEffect">取 消</el-button>
        <el-button type="primary" @click="submitConfigEffect('formConfigEffect')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getCurrDateTime
} from '../../../../../assets/scripts/date2string';

import { 
  api 
} from '../../../../../api/console';

import {
  QuickAppConfig
} from '../../../../../assets/scripts/appconfig';

import axios from 'axios';

export default {
  data() {
    return {
      hasSavedAppIssue: false,  // 控制按钮是否无效，是否已经保存

      uploadHeader:{
        'x-auth-token':localStorage.getItem("x-auth-token")
      },
      // 效果数据回传设置弹窗
      dialogConfigEffectVisible: false,
      formConfigEffectCache: { // 上传数据
        operatorId: null,
        channelSlotId: null,
        effectMode: null,
        effectRate: null,
        effectAdClick: null,
        effectAdView: null,
        effectAdView2: null,
        effectArpu: null,
        effectArpu2: null,
        effectAdPrice: null,
        effectRoi: null,
        effectIgnore: null,
      },
      formConfigEffect: {
        operatorId: null,
        channelSlotId: null,
        effectMode: null,
        effectRate: null,
        effectAdClick: null,
        effectAdView: null,
        effectAdView2: null,
        effectArpu: null,
        effectArpu2: null,
        effectAdPrice: null,
        effectRoi: null,
        effectIgnore: null,
        effectUnify: null,
      },
      effectIgnoreOppo: false,
      effectIgnoreVivo: false,
      effectUnifySwitch: false,
      
      editChannelSlotId: null,
      editStatChanneSlot: false,

      effectModes: ['广告点击','广告曝光','用户ARPU','广告价格','参与测评','广告曝光&价格','查看测评结果'],
      effectModeSelected: [],
      effectModes2: ['广告点击&价格','用户ARPU2','用户ARPU3','广告价格2','广告曝光&价格2','ROI'],
      effectModeSelected2: [],
      
      // 效果数据回传校验规则
      configEffectRules: {
          channelSlotId: [
              { required: true, message: '无效的渠道位置', trigger: 'blur' }
          ],
          effectMode: [
              { required: true, message: '请选择效果回传模式', trigger: 'blur' }
          ],
          effectRate: [
              { required: true, message: '请输入效果回传比例', trigger: 'blur' }
          ]   
      },

      // 上传文件列表
      uploadFileList:[],
      // 应用对象数据
      formData: { 
        // 公共配置
        app_id: null,
        app_type: null,
        issue_platform: null,
        issue_flow: null,
        channel_id: null,
        channel_slot_id: null,
        measure_id: null,
        book_id: null,
        shortplay_id: null,
        cookbook_id: null,
        health_class_id: null,
        health_id: null,
        issue_account: null,
        issue_account_name: null,
        issue_account_key: null,
        oppo_api_id: null,
        oppo_api_key: null,
        vivo_api_ds: null,
        baidu_api_akey: null,
        // 投放账号列表
        issue_accounts:[],
        // 回传设置
        appEffect:null,
        issue_effect_type: null,
        issue_cfg_scene: null,
        issue_ad_scene: null,
        issue_ad_bidbase: null,
        issue_company: null,
        issue_product: null,
        issue_domain: null,
        issue_bg_campaign: null,
        issue_time: null,
        approve_status: 2,
        authorized_operators: null,
        is_ko: 0,
      },
      
      channels: null,         //渠道列表
      channelSlots: null,     //渠道位置

      appraises: null,        //测评列表(新)
      appraiseTemplets: null, //测评模版映射表(新)

      books: null,            //小说
      bookNames: null,        //小说名称

      shortplays: null,       //短剧

      // 授权操作员列表
      authorizeOperators: [],
      
      // 投放平台、流量、效果列表
      issuePlatforms: null,
      issueFlows: null,
      issueEffects: null,

      // 有效操作员列表 
      availableOperators: [], 

      // 是否显示选择操作员
      selectOperatorVisible: false,  

      // 已选择操作员
      selectedOperatorId: null,

      // 应用
      apps: null,

      // 应用类型
      appTypes: {
        5: "H5",
        61: "OPPO",
        62: "VIVO",
        63: "小米",
        65: "华为",
      },

      // 菜谱
      cookbooks: {
        1:    '红烧肉',
        2:	  '排骨玉米汤',
        3:	  '鱼香肉丝',
        4:	  '炸酱面',
        5:	  '糖醋排骨',
        6:	  '可乐鸡翅',
        7:	  '红焖羊排萝卜',
        8:	  '木须肉',
        9:	  '酸辣土豆丝',
        10:	  '芒果圆子西米露',
        11:   '白菜豆腐煲',
        12:	  '油闷大虾',
        13:	  '煎蛋白菜豆腐汤',
        14:	  '照烧肥牛饭',
        15:   '东北锅包肉',
        16:   '家庭版葡式蛋挞',
        17:	  '秋葵',
        18:	  '三鲜饺子',
        19:	  '咖喱鸡肉饭',
        20:	  '酸辣汤',
        99999:'转盘'
      },

      // 健康养生
      healthes: {
        1:    '警惕亚健康，守护生命活力',
        2:	  '如何呵护颈椎健康',
        3:	  '如何远离腰椎问题',
        4:	  '关注 “工作病”，守护职场健康',
        5:	  '女性经期养生指南',
        6:	  '孕期养生指南',
        7:	  '老年人如何吃才健康？',
        8:	  '老年常见疾病如何预防？',
        9:	  '运动，让老人更健康的秘诀',
        10:	  '老年人觉少正常吗？',
        11:   '解压木鱼真的解压吗',
        12:	  '音乐如何助眠',
        13:	  '摆脱睡眠困扰',
        14:	  '冥想的妙用',
        15:   '冥想，减压神器',
        16:   '音乐，让睡眠更轻松',
        17:	  '常见食材的养生功效',
        18:	  '慢食文化与健康',
        19:	  '胶原蛋白的秘密',
        20:	  '食物搭配禁忌表',
        21:   '暖冬滋补秘籍',
        22:   '顺应节气，吃出健康',
        23:   '如何健康瘦？',
        24:   '八段锦古法养生',
        25:   '上班族如何保持日常运动',
        26:   '日常运动养生小技巧',
        27:   '瑜伽的好处',
        28:   '传统健身的养生智慧',
        29:   '选择合适的户外运动',
        30:   '科学健身',
      },

      health_classes: {
        0:    '食材养生',
        1:	  '冥想疗愈',
        2:	  '运动养生',
        3:	  '养生人群',
      },
      
      // 广告资源位打底广告场景
      adResourceBidbases: {
        1: '打底场景 1',
        2: '打底场景 2',
        3: '打底场景 3',
        4: '打底场景 4',
        5: '打底场景 5',
      },

      // 广告场景
      issueAdScenes: {
        1: '广告场景 1',
        2: '广告场景 2',
        3: '广告场景 3',
        4: '广告场景 4',
        5: '广告场景 5',
      },

      // 应用配置场景
      issueCfgScenes: {
        1: '配置场景1',
        2: '配置场景2',
        3: '配置场景3',
        4: '配置场景4',
        5: '配置场景5',
      },

      // 投放快手主体
      issueCompanies: {
         6: '黄冈市黄州区锦画百货店',
         7: '黄冈市黄州区梓樱百货店',
         8: '黄冈市黄州区暖语百货店',
         9: '黄冈市黄州区思梵百货店',
        10: '黄冈市黄州区谢忆昔百货店',
        11: '黄冈市黄州区琴旺庆百货店',
        12: '黄冈市黄州区梦璃百货店',
        15: '黄冈市黄州区鹿溪百货店',
        16: '黄冈市黄州区初醒心百货店',
        17: '黄冈市黄州区灵希百货店',
        18: '厦门晴弥乔溢网络有限公司',
				19: '厦门云期雨悠网络有限公司',
      },

      issueProducts: {
         9: '幸运猪',
				15: '爱测评',
        26: '爱生活',
				16: '肥猫免费测评',
				18: '肥猫小说',
				20: '飞猫免费小说',
        28: '胖猫免费测评',
      },

      // 投放UC主体
      issueUcCompanies: {
        1: '有礼（天津）网络有限公司',
        2: '万维感知（北京）科技有限公司',
        3: '天津肥猫科技有限公司',
        4: '万维智创（杭州）科技有限公司',
      },

      // 投放指定背景
      issueBgCampaigns: {
        1171: '壁纸',
        1174: '走路赚钱',
        1180: '天气',
        1181: '运动',
        1182: '养生',
        1183: '红包',
        9999: '菜谱',
        88888: '图书',
      },

      // 投放UC域名
      issueUcDomains: {
        1: 'coscdn.aiseeking.com',
        2: 'coscdn.ivknow.com',
        3: 'coscdn.uicats.com',
        4: 'coscdn.ivinno.com',
        5: 'coscdn.youlimeta.com',
        6: 'coscdn.irknow.com',
      },

      // 状态
      issueStatusMap: {
        1: "有效",
        0: "无效"
      },      
      
      // 校验规则
      formRules: {
        app_id: [
          { required: true, message: '请选择应用', trigger: 'blur' }
        ],
        app_type: [
          { required: true, message: '请选择应用类型', trigger: 'blur' }
        ],
        issue_platform: [
          { required: true, message: '请选择投放平台', trigger: 'blur' }
        ],
        channel_id: [
          { required: true, message: '请选择渠道', trigger: 'blur' },
        ],
        channel_slot_id: [
          { required: true, message: '请输入渠道位置', trigger: 'blur' },
        ],
        issue_accounts: [
          { required: true, message: '请导入投放账户', trigger: 'blur' },
        ],
        appEffect: [
          { required: true, message: '请配置回传设置', trigger: 'blur' },
        ],
      },

      // 操作员对象
      operator: null,
    };
  },
  
  async created() {
    // 加载用户对象
    this.operator = JSON.parse(localStorage.getItem('operator'));
    // 初始化数据
    this.initApps();
    this.initAppraises();
    this.initBooks();
    this.initShortplays();
    await this.initChannels();
    this.initIssuePlatforms();
    this.initOperators();
    // 获取复制数据
    if(this.$route.params && this.$route.params.app_issue_id) {
      this.formData.app_id = this.$route.params.app_id;
      this.formData.app_type = this.$route.params.app_type;
      this.formData.issue_platform = this.$route.params.issue_platform;
      this.formData.issue_flow = this.$route.params.issue_flow;
      this.formData.measure_id = this.$route.params.measure_id;
      this.formData.book_id = this.$route.params.book_id;
      this.formData.shortplay_id = this.$route.params.shortplay_id;
      this.formData.cookbook_id = this.$route.params.cookbook_id;
      this.formData.health_class_id = this.$route.params.health_class_id;
      this.formData.health_id = this.$route.params.health_id;
      this.formData.appraise_id = this.$route.params.appraise_id;
      this.formData.channel_id = this.$route.params.channel_id;
      this.formData.issue_effect_type = this.$route.params.issue_effect_type;
      this.formData.issue_cfg_scene = this.$route.params.issue_cfg_scene;
      this.formData.issue_ad_scene = this.$route.params.issue_ad_scene;
      this.formData.issue_ad_bidbase = this.$route.params.issue_ad_bidbase;
      // 加载推广渠道流量和效果
      if(this.formData.issue_platform) {
        this.loadIssueFlows();
        this.loadIssueEffects();
      }
    }      
  },

  methods: {
    // 效果数据回传弹窗
    showDialog() {
      this.dialogConfigEffectVisible = true;
      this.$refs['formConfigEffect'] && this.$refs['formConfigEffect'].resetFields()
      this.formConfigEffect = Object.assign({}, this.formConfigEffectCache)
      // 效果数据回传模式
      this.effectModeSelected = [];
      this.effectModeSelected2 = [];
      if(this.formConfigEffect.effectMode) {
        this.formConfigEffect.effectMode = parseInt(this.formConfigEffect.effectMode);
        if(Math.floor(this.formConfigEffect.effectMode % 10) == 1) {
          this.effectModeSelected.push('广告点击');
        }
        if(Math.floor((this.formConfigEffect.effectMode / 10) % 10) == 1) {
          this.effectModeSelected.push('广告曝光');
        }
        if(Math.floor((this.formConfigEffect.effectMode / 100) % 10) == 1) {
          this.effectModeSelected.push('用户ARPU');
        }
        if(Math.floor((this.formConfigEffect.effectMode / 100) % 10) == 2) {
          this.effectModeSelected2.push('用户ARPU2');
        }
        if(Math.floor((this.formConfigEffect.effectMode / 100) % 10) == 3) {
          this.effectModeSelected2.push('用户ARPU3');
        }
        if(Math.floor((this.formConfigEffect.effectMode / 1000) % 10) == 1) {
          this.effectModeSelected.push('广告价格');
        }
        if(Math.floor((this.formConfigEffect.effectMode / 1000) % 10) == 2) {
          this.effectModeSelected2.push('广告价格2');
        }
        if(Math.floor((this.formConfigEffect.effectMode / 10000) % 10) == 1) {
          this.effectModeSelected.push('参与测评');
        }
        if(Math.floor((this.formConfigEffect.effectMode / 100000) % 10) == 1) {
          this.effectModeSelected.push('广告曝光&价格');
        }
        if(Math.floor((this.formConfigEffect.effectMode / 100000) % 10) == 2) {
          this.effectModeSelected2.push('广告曝光&价格2');
        }
        if(Math.floor((this.formConfigEffect.effectMode / 1000000) % 10) == 1) {
          this.effectModeSelected.push('查看测评结果');
        }
        if(Math.floor((this.formConfigEffect.effectMode / 10000000) % 10) == 1) {
          this.effectModeSelected2.push('广告点击&价格');
        }
        if(Math.floor((this.formConfigEffect.effectMode / 100000000) % 10) == 1) {
          this.effectModeSelected2.push('ROI');
        }
      }
      // 效果回传比例
      if(this.formConfigEffect.effectRate) {
        this.formConfigEffect.effectRate = this.formConfigEffect.effectRate / 100;
      }
      // 效果回传价格
      if(this.formConfigEffect.effectArpu) {
        this.formConfigEffect.effectArpu = this.formConfigEffect.effectArpu / 10000.0;
      }
      if(this.formConfigEffect.effectArpu2) {
        this.formConfigEffect.effectArpu2 = this.formConfigEffect.effectArpu2 / 10000.0;
      }
      if(this.formConfigEffect.effectAdPrice) {
        this.formConfigEffect.effectAdPrice = this.formConfigEffect.effectAdPrice / 10000.0;
      }
      if(this.formConfigEffect.effectRoi) {
        this.formConfigEffect.effectRoi = this.formConfigEffect.effectRoi / 10000.0;
      }
      // 效果回传忽略设备
      if((this.formConfigEffect.effectIgnore & 1) == 1) {
        this.effectIgnoreOppo = true;
      } else {
        this.effectIgnoreOppo = false;
      }
      if((this.formConfigEffect.effectIgnore & 2) == 2) {
        this.effectIgnoreVivo = true;
      } else {
        this.effectIgnoreVivo = false;
      }
      // 统一回传
      if(this.formConfigEffect.effectUnify == 1) {
        this.effectUnifySwitch = true;
      } else {
        this.effectUnifySwitch = false;
      }
    },
    // 配置投放效果数据回传调整
    async configEffectModeChange() {
      // 效果数据回传模式
      this.effectModeSelected = [];
      this.effectModeSelected2 = [];
      if(this.formConfigEffect.effectMode) {
        this.formConfigEffect.effectMode = parseInt(this.formConfigEffect.effectMode);
        if(Math.floor(this.formConfigEffect.effectMode % 10) == 1) {
          this.effectModeSelected.push('广告点击');
        }
        if(Math.floor((this.formConfigEffect.effectMode / 10) % 10) == 1) {
          this.effectModeSelected.push('广告曝光');
        }
        if(Math.floor((this.formConfigEffect.effectMode / 100) % 10) == 1) {
          this.effectModeSelected.push('用户ARPU');
        }
        if(Math.floor((this.formConfigEffect.effectMode / 100) % 10) == 2) {
          this.effectModeSelected2.push('用户ARPU2');
        }
        if(Math.floor((this.formConfigEffect.effectMode / 100) % 10) == 3) {
          this.effectModeSelected2.push('用户ARPU3');
        }
        if(Math.floor((this.formConfigEffect.effectMode / 1000) % 10) == 1) {
          this.effectModeSelected.push('广告价格');
        }
        if(Math.floor((this.formConfigEffect.effectMode / 1000) % 10) == 2) {
          this.effectModeSelected2.push('广告价格2');
        }
        if(Math.floor((this.formConfigEffect.effectMode / 10000) % 10) == 1) {
          this.effectModeSelected.push('参与测评');
        }
        if(Math.floor((this.formConfigEffect.effectMode / 100000) % 10) == 1) {
          this.effectModeSelected.push('广告曝光&价格');
        }
        if(Math.floor((this.formConfigEffect.effectMode / 100000) % 10) == 2) {
          this.effectModeSelected2.push('广告曝光&价格2');
        }
        if(Math.floor((this.formConfigEffect.effectMode / 1000000) % 10) == 1) {
          this.effectModeSelected.push('查看测评结果');
        }
        if(Math.floor((this.formConfigEffect.effectMode / 10000000) % 10) == 1) {
          this.effectModeSelected2.push('广告点击&价格');
        }
        if(Math.floor((this.formConfigEffect.effectMode / 100000000) % 10) == 1) {
          this.effectModeSelected2.push('ROI');
        }
      }
    },
    async onCancelConfigEffect() {
      this.dialogConfigEffectVisible = false;
    },
    async submitConfigEffect(form){
      // 验证表单数据
      this.$refs[form].validate((valid) => {
          if (valid) {
            // 显示页面加载
            const loading = this.$loading({
                lock: true,
                text: 'Processing ......',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)',
                target: '.box'
            });
            // 设置效果回传模式
            let selectedArpu = 0;
            let selectedArpu2 = 0;
            let selectedArpu3 = 0;
            let selectedAdPrice = 0;
            let selectedAdPrice2 = 0;
            let selectedAdPriceView = 0;
            let selectedAdPriceView2 = 0;
            this.formConfigEffect.effectMode = 0;
            for(let mode of this.effectModeSelected) {
              if(mode == '广告点击') {
                this.formConfigEffect.effectMode += 1;
              } else if(mode == '广告曝光') {
                this.formConfigEffect.effectMode += 10;
              } else if(mode == '用户ARPU') {
                this.formConfigEffect.effectMode += 100;
                selectedArpu = 1;
              } else if(mode == '广告价格') {
                this.formConfigEffect.effectMode += 1000;
                selectedAdPrice = 1;
              } else if(mode == '参与测评') {
                this.formConfigEffect.effectMode += 10000;
              } else if(mode == '广告曝光&价格') {
                this.formConfigEffect.effectMode += 100000;
                selectedAdPriceView = 1;
              } else if(mode == '查看测评结果') {
                this.formConfigEffect.effectMode += 1000000;
              }
            }
            for(let mode of this.effectModeSelected2) {
              if(mode == '用户ARPU2') {
                this.formConfigEffect.effectMode += 200;
                selectedArpu2 = 1;
              } else if(mode == '用户ARPU3') {
                this.formConfigEffect.effectMode += 300;
                selectedArpu3 = 1;
              } else if(mode == '广告价格2') {
                this.formConfigEffect.effectMode += 2000;
                selectedAdPrice2 = 1;
              } else if(mode == '广告曝光&价格2') {
                this.formConfigEffect.effectMode += 200000;
                selectedAdPriceView2 = 1;
              } else if(mode == '广告点击&价格') {
                this.formConfigEffect.effectMode += 10000000;
              } else if(mode == 'ROI') {
                this.formConfigEffect.effectMode += 100000000;
              }
            }
            // 校验选择合理性
            if(selectedArpu==1 && (selectedArpu2==1 || selectedArpu3==1)
                || selectedArpu2==1 && (selectedArpu==1 || selectedArpu2==1)
                || selectedArpu3==1 && (selectedArpu==1 || selectedArpu2==1)
                || selectedAdPrice==1 && selectedAdPrice2==1
                || selectedAdPriceView==1 && selectedAdPriceView2==1) {
              this.$message('回调模式选择冲突', "warning");
              // 关闭加载
              loading.close();
              return;
            }
            // 广告曝光和价格与广告价格不能同时选择
            if((selectedAdPrice==1 || selectedAdPrice2==1) && (selectedAdPriceView==1 || selectedAdPriceView2==1)) {
              this.$message('回调模式选择冲突', "warning");
              // 关闭加载
              loading.close();
              return;
            }
            // roi 必须跟其他模式并存
            if(this.formConfigEffect.effectMode == 100000000) {
              this.$message('ROI回传模型必须与其他模式并存', "warning");
              // 关闭加载
              loading.close();
              return;
            }
            // 回传比例
            this.formConfigEffect.effectRate = this.formConfigEffect.effectRate * 100;
            // 效果回传价格
            if(this.formConfigEffect.effectArpu) {
              this.formConfigEffect.effectArpu = Math.floor(this.formConfigEffect.effectArpu * 10000);
            }
            if(this.formConfigEffect.effectArpu2) {
              this.formConfigEffect.effectArpu2 = Math.floor(this.formConfigEffect.effectArpu2 * 10000);
            }
            if(this.formConfigEffect.effectAdPrice) {
              this.formConfigEffect.effectAdPrice = Math.floor(this.formConfigEffect.effectAdPrice * 10000);
            }
            if(this.formConfigEffect.effectRoi) {
              this.formConfigEffect.effectRoi = Math.floor(this.formConfigEffect.effectRoi * 10000);
            }
            // 忽略设备
            this.formConfigEffect.effectIgnore = 0;
            if(this.effectIgnoreOppo) {
              this.formConfigEffect.effectIgnore += 1;
            }
            if(this.effectIgnoreVivo) {
              this.formConfigEffect.effectIgnore += 2;
            }
            // 统一回传
            if(this.effectUnifySwitch) {
              this.formConfigEffect.effectUnify = 1;
            } else {
              this.formConfigEffect.effectUnify = 0;
            }
            // 设置操作员ID
            let operator = JSON.parse(localStorage.getItem('operator'));
            this.formConfigEffect.operatorId = operator.operatorId;
            this.formConfigEffectCache = Object.assign({}, this.formConfigEffect);
            this.formData.appEffect = Object.assign({}, this.formConfigEffect);
            // 关闭加载
            loading.close();
            // 关闭弹窗
            this.dialogConfigEffectVisible = false;
          }
      });
    },

    // 上传素材文件
    uploadAppIssueBatchFile(cid){
      return this.$api.apiQuickAppIssueBatchUpload(cid);
    },

    // 上传成功回调
    handleUploadSuccess(response, file, fileList) {
      console.log('handleUploadSuccess',response.content, file, fileList)
      if (response.result === 1) {
        this.formData.issue_accounts = response.content.map(item => {
          return {
            issue_account: item.issue_account,
            channel_slot_id: item.channel_slot_id,
            issue_hap_url:'',
            issue_h5_url:'',
            issue_tv_url:'',
            issue_tc_url:''
          }
        })
        this.$message(response.message, "success");
      }
    },
    // 删除上传
    handleUploadRemove() {
      console.log('handleUploadRemove')
      this.formData.issue_accounts = []
    },
    // 初始化应用
    async initApps(){
      // 清空当前集合数据
      this.apps = null;
      // 调用接口
      let res = await this.$api.apiCommonApps();
      // 应用数据存进data
      this.apps = res.content;
    },

    // 初始化渠道
    async initChannels() {
      // 清空当前渠道
      this.channels = [];
      // 调用接口
      let res = await this.$api.apiCommonChannels();
      // 保存结果
      this.channels = res.content;
    },

    // 初始化测评(新)
    async initAppraises() {
      // 清空当前测评
      this.appraises = null;
      // 调用接口
      let res = await this.$api.apiCommonAppraises();
      // 保存结果
      this.appraises = res.content;
      // 保存测评模版映射
      this.appraiseTemplets = {};
      this.appraises.forEach((appraise) => {
        this.appraiseTemplets[appraise.appraise_id] = appraise.templet_tag ? appraise.templet_tag : 'tpltxt_question';
      });
    },

    // 初始化小说
    async initBooks() {
      // 清空当前测评
      this.books = null;
      // 调用接口
      let res = await this.$api.apiCommonBooks();
      // 保存结果
      this.books = res.content;
      // 保存小说名称
      this.bookNames = {};
      this.books.forEach((book) => {
        this.bookNames[book.book_id] = book.book_name;
      });
    },

    // 初始化短剧
    async initShortplays() {
      // 清空当前短剧列表
      this.shortplays = null;
      // 调用接口
      let res = await this.$api.apiCommonShortplays();
      // 保存结果
      this.shortplays = res.content;
    },

    // 初始化发布平台
    async initIssuePlatforms() {
      // 清空当前渠道
      this.issuePlatforms = null;
      // 调用接口
      let res = await this.$api.apiCommonIssuePlatforms();
      // 保存结果
      this.issuePlatforms = res.content;
    },

    // 修改发布平台
    async changedIssuePlatforms() {
      this.loadIssueFlows(1);
      this.loadIssueEffects(1);
    },

    // 加载发布平台流量类型
    async loadIssueFlows(mode) {
      // 清空当前流量类型
      if(mode == 1) {
        this.formData.issue_flow = null;
      }
      this.issueFlows = null;
      // 调用接口
      let res = await this.$api.apiCommonIssueFlows({issuePlatformTag: this.formData.issue_platform});
      // 保存结果
      this.issueFlows = res.content;
    },

    // 加载发布平台效果类型
    async loadIssueEffects(mode) {
      // 清空当前流量类型
      if(mode == 1) {
        this.formData.issue_effect_type = null;
      }
      this.issueEffects = null;
      // 调用接口
      let res = await this.$api.apiCommonIssueEffects({issuePlatformTag: this.formData.issue_platform});
      // 保存结果
      this.issueEffects = res.content;
    },

    // 选择效果数据回传类型
    async changedIssueEffect() {
      this.$forceUpdate();
    },
    
    // 生成链接
    async onGenerate() {
      // 判断应用业务线
      if(!this.formData.app_id) {
        this.$message("请选择应用", "warning");
        return;
      }
      // 生成快应用链接
      if(this.apps.find(item => item.app_id == this.formData.app_id).business_line == 'quickapp') {
        this.formData.issue_accounts.forEach(v => this.onQuickappGenerate(v))
        return;
      }
      // 生成wechat h5 应用链接
      if(this.apps.find(item => item.app_id == this.formData.app_id).business_line == 'appraise_pay') {
        this.formData.issue_accounts.forEach(v => this.onWechatH5Generate(v))
        return;
      }
    },

    // 生成Wechat H5应用链接
    async onWechatH5Generate(issueAccount) {
      // 设置应用类型
      this.formData.app_type = this.apps.find(item => item.app_id == this.formData.app_id).app_type;

      // 定义目标页面
      let sip = '';

      // 针对不同投放平台，生成监测链接
      if(this.formData.issue_platform=='gdt') {
        sip = 'tg';
        issueAccount.issue_tc_url = 'https://tracking.aiseeking.com/tracking/v1/quick/click?appid=' + this.formData.app_id + '&apptype=' + this.formData.app_type + '&cid=' + this.formData.channel_id + '&csid=' + issueAccount.channel_slot_id + '&target=gdt&advertiserid=__ACCOUNT_ID__&adid=__AD_ID__&creativeid=__DYNAMIC_CREATIVE_ID__&ip=__IP__&os=__DEVICE_OS_TYPE__&imei=__MUID__&oaid=__HASH_OAID__&reqid=__CLICK_ID__&reqtime=__CLICK_TIME__&referer=__CALLBACK__&rtaexp=__REQUEST_ID__&resolution=__IMPRESSION_ID__&userAgent=__USER_AGENT__';
        issueAccount.issue_tv_url = 'https://tracking.aiseeking.com/tracking/v1/quick/view?appid=' + this.formData.app_id + '&apptype=' + this.formData.app_type + '&cid=' + this.formData.channel_id + '&csid=' + issueAccount.channel_slot_id + '&target=gdt&advertiserid=__ACCOUNT_ID__&adid=__AD_ID__&creativeid=__DYNAMIC_CREATIVE_ID__&ip=__IP__&os=__DEVICE_OS_TYPE__&imei=__MUID__&oaid=__HASH_OAID__&reqid=__CLICK_ID__&reqtime=__CLICK_TIME__&referer=__CALLBACK__&rtaexp=__REQUEST_ID__&resolution=__IMPRESSION_ID__&userAgent=__USER_AGENT__';
      } else {
        sip = 'common';
        issueAccount.issue_tc_url = '';
        issueAccount.issue_tv_url = '';
      }

      // 基于应用，生成投放链接
      if(this.formData.app_id==23) {
        issueAccount.issue_h5_url = 'https://coscdn.aiseeking.com/appraisepay/wh5/mbti/v3/index.html?sip=' + sip + '5&cid='+ this.formData.channel_id + '&csid=' + issueAccount.channel_slot_id;
      }
    },

    // 生成快应用链接
    async onQuickappGenerate(issueAccount) {
      
      // 定义目标页面
      let target = '';
      let sip = '';
      
      // 针对不同投放平台，生成监测链接
      if(this.formData.issue_platform=='oppo') {
        target = 'oppo';
        sip = 'ou';
        issueAccount.issue_tc_url = 'https://tracking.aiseeking.com/tracking/v1/quick/click?appid=' + this.formData.app_id + '&apptype=' + this.formData.app_type + '&cid=' + this.formData.channel_id + '&csid=' + issueAccount.channel_slot_id + '&target=oppo&os=$os$&osVersion=$ov$&model=$m$&lang=$lan$&country=$c$&width=$w$&height=$h$&pkg=$pkg$&appVersion=$av$&userAgent=$ua$&referer=$rf$&net=$nt$&imei=$im$&oaid=__OAID__&adid=$ad$&adname=$an$&reqid=$req$';
        issueAccount.issue_tv_url = 'https://tracking.aiseeking.com/tracking/v1/quick/view?appid=' + this.formData.app_id + '&apptype=' + this.formData.app_type + '&cid=' + this.formData.channel_id + '&csid=' + issueAccount.channel_slot_id + '&target=oppo&os=$os$&osVersion=$ov$&model=$m$&lang=$lan$&country=$c$&width=$w$&height=$h$&pkg=$pkg$&appVersion=$av$&userAgent=$ua$&referer=$rf$&net=$nt$&imei=$im$&oaid=__OAID__&adid=$ad$&adname=$an$&reqid=$req$';
      } else if(this.formData.issue_platform=='vivo') {
        target = 'vivo';
        sip = 'vu';
        issueAccount.issue_tc_url = 'https://tracking.aiseeking.com/tracking/v1/quick/click?appid=' + this.formData.app_id + '&apptype=' + this.formData.app_type + '&cid=' + this.formData.channel_id + '&csid=' + issueAccount.channel_slot_id + '&target=vivo&os=__OS__&osVersion=__OSVERSION__&imei=__IMEI__&oaid=__OAID__&userAgent=__UA__&model=__MODEL__&lang=__LANG__&reqid=__REQUESTID__&net=__NETTYPE__&adname=__ADNAME__&ip=__IP__&location=__LOCATION__&oaidplain=__OAIDPLAIN__&androidid=__ANDROIDID__&reqtime=__REQUESTTIME__&advertiserid=__ADVERTISERID__&resolution=__RESOLUTION__&rtaexp=__RTAEXP__&adid=__ADID__&clickid=__CLICKID__&ts=__TS__';
        issueAccount.issue_tv_url = 'https://tracking.aiseeking.com/tracking/v1/quick/view?appid=' + this.formData.app_id + '&apptype=' + this.formData.app_type + '&cid=' + this.formData.channel_id + '&csid=' + issueAccount.channel_slot_id + '&target=vivo&os=__OS__&osVersion=__OSVERSION__&imei=__IMEI__&oaid=__OAID__&userAgent=__UA__&model=__MODEL__&lang=__LANG__&reqid=__REQUESTID__&net=__NETTYPE__&adname=__ADNAME__&ip=__IP__&location=__LOCATION__&oaidplain=__OAIDPLAIN__&androidid=__ANDROIDID__&reqtime=__REQUESTTIME__&advertiserid=__ADVERTISERID__&resolution=__RESOLUTION__&rtaexp=__RTAEXP__&adid=__ADID__&clickid=__CLICKID__&ts=__TS__';
      } else if(this.formData.issue_platform=='huawei') {
        target = 'issue';
        sip = 'hw';
        issueAccount.issue_tc_url = 'https://tracking.aiseeking.com/tracking/v1/quick/click?appid=' + this.formData.app_id + '&apptype=' + this.formData.app_type + '&cid=' + this.formData.channel_id + '&csid=' + issueAccount.channel_slot_id + '&target=huawei';
        issueAccount.issue_tv_url = 'https://tracking.aiseeking.com/tracking/v1/quick/view?appid=' + this.formData.app_id + '&apptype=' + this.formData.app_type + '&cid=' + this.formData.channel_id + '&csid=' + issueAccount.channel_slot_id + '&target=huawei';
      } else if(this.formData.issue_platform=='qtt') {
        target = 'qtt';
        sip = 'qt';
        issueAccount.issue_tc_url = 'https://tracking.aiseeking.com/tracking/v1/quick/click?appid=' + this.formData.app_id + '&apptype=' + this.formData.app_type + '&cid=' + this.formData.channel_id + '&csid=' + issueAccount.channel_slot_id + '&target=qtt&os=__OS__&imei=__IMEIMD5__&width=__SCREEN_WIDTH__&height=__SCREEN_HEIGHT__&userAgent=__UA__&ip=__IP__&oaidplain=__OAID__&oaid=__OAIDMD5__&referer=__CALLBACK_URL__&ts=__TS__';
        issueAccount.issue_tv_url = 'https://tracking.aiseeking.com/tracking/v1/quick/view?appid=' + this.formData.app_id + '&apptype=' + this.formData.app_type + '&cid=' + this.formData.channel_id + '&csid=' + issueAccount.channel_slot_id + '&target=qtt&os=__OS__&imei=__IMEIMD5__&width=__SCREEN_WIDTH__&height=__SCREEN_HEIGHT__&userAgent=__UA__&ip=__IP__&oaidplain=__OAID__&oaid=__OAIDMD5__&referer=__CALLBACK_URL__&ts=__TS__';
      } else if(this.formData.issue_platform=='kuaishou') {
        target = 'issue';
        sip = 'ks';
        issueAccount.issue_tc_url = 'https://tracking.aiseeking.com/tracking/v1/quick/click?appid=' + this.formData.app_id + '&apptype=' + this.formData.app_type + '&cid=' + this.formData.channel_id + '&csid=' + issueAccount.channel_slot_id + '&target=kuaishou&advertiserid=__ACCOUNTID__&adid=__AID__&creativeid=__CID__&oaidplain=__OAID__&oaid=__OAID2__&imei=__IMEI2__&androidid=__ANDROIDID2__&os=__OS__&model=__MODEL__&ip=__IP__&referer=__CALLBACK__&userAgent=__UA__&ts=__TS__';
        issueAccount.issue_tv_url = 'https://tracking.aiseeking.com/tracking/v1/quick/view?appid=' + this.formData.app_id + '&apptype=' + this.formData.app_type + '&cid=' + this.formData.channel_id + '&csid=' + issueAccount.channel_slot_id + '&target=kuaishou&advertiserid=__ACCOUNTID__&adid=__AID__&creativeid=__CID__&oaidplain=__OAID__&oaid=__OAID2__&imei=__IMEI2__&androidid=__ANDROIDID2__&os=__OS__&model=__MODEL__&ip=__IP__&referer=__CALLBACK__&userAgent=__UA__&ts=__TS__';
      } else if(this.formData.issue_platform=='toutiao') {
        target = 'tt';
        sip = 'tt';
        issueAccount.issue_tc_url = 'https://tracking.aiseeking.com/tracking/v1/quick/click?appid=' + this.formData.app_id + '&apptype=' + this.formData.app_type + '&cid=' + this.formData.channel_id + '&csid=' + issueAccount.channel_slot_id + '&target=toutiao&advertiserid=__ADVERTISER_ID__&adid=__PROMOTION_ID__&adname=__PROMOTION_NAME__&ip=__IP__&os=__OS__&model=__MODEL__&imei=__IMEI__&oaid=__OAID_MD5__&oaidplain=__OAID__&userAgent=__UA__&androidid=__ANDROIDID__&ts=__TS__&reqid=__REQUEST_ID__&referer=__CALLBACK_PARAM__';
        issueAccount.issue_tv_url = 'https://tracking.aiseeking.com/tracking/v1/quick/view?appid=' + this.formData.app_id + '&apptype=' + this.formData.app_type + '&cid=' + this.formData.channel_id + '&csid=' + issueAccount.channel_slot_id + '&target=toutiao&advertiserid=__ADVERTISER_ID__&adid=__PROMOTION_ID__&adname=__PROMOTION_NAME__&ip=__IP__&os=__OS__&model=__MODEL__&imei=__IMEI__&oaid=__OAID_MD5__&oaidplain=__OAID__&userAgent=__UA__&androidid=__ANDROIDID__&ts=__TS__&reqid=__REQUEST_ID__&referer=__CALLBACK_PARAM__';
      } else if(this.formData.issue_platform=='gdt') {
        target = 'issue';
        sip = 'tg';
        issueAccount.issue_tc_url = 'https://tracking.aiseeking.com/tracking/v1/quick/click?appid=' + this.formData.app_id + '&apptype=' + this.formData.app_type + '&cid=' + this.formData.channel_id + '&csid=' + issueAccount.channel_slot_id + '&target=gdt&advertiserid=__ACCOUNT_ID__&adid=__ADGROUP_ID__&adname=__ADGROUP_NAME__&creativeid=__DYNAMIC_CREATIVE_ID__&location=__SITE_SET_NAME__&ip=__IP__&os=__DEVICE_OS_TYPE__&imei=__MUID__&oaid=__HASH_OAID__&reqid=__CLICK_ID__&reqtime=__CLICK_TIME__&referer=__CALLBACK__&rtaexp=__REQUEST_ID__&resolution=__IMPRESSION_ID__&userAgent=__USER_AGENT__';
        issueAccount.issue_tv_url = 'https://tracking.aiseeking.com/tracking/v1/quick/view?appid=' + this.formData.app_id + '&apptype=' + this.formData.app_type + '&cid=' + this.formData.channel_id + '&csid=' + issueAccount.channel_slot_id + '&target=gdt&advertiserid=__ACCOUNT_ID__&adid=__ADGROUP_ID__&adname=__ADGROUP_NAME__&creativeid=__DYNAMIC_CREATIVE_ID__&location=__SITE_SET_NAME__&ip=__IP__&os=__DEVICE_OS_TYPE__&imei=__MUID__&oaid=__HASH_OAID__&reqid=__CLICK_ID__&reqtime=__CLICK_TIME__&referer=__CALLBACK__&rtaexp=__REQUEST_ID__&resolution=__IMPRESSION_ID__&userAgent=__USER_AGENT__';
      } else if(this.formData.issue_platform=='alipay') {
        target = 'issue';
        sip = 'ap';
        issueAccount.issue_tc_url = 'https://tracking.aiseeking.com/tracking/v1/quick/click?appid=' + this.formData.app_id + '&apptype=' + this.formData.app_type + '&cid=' + this.formData.channel_id + '&csid=' + issueAccount.channel_slot_id + '&target=alipay&os=__OS__&ip=__IP__&imei=__IMEI__&oaid=__OAID_MD5__&model=__IDFA_MD5__&advertiserid=__PRINCIPAL_ID__&adid=__GROUP_ID__&creativeid=__AD_ID__&resolution=__CID__&rtaexp=__CAID__&androidid=__OPENID__&reqid=__REQUEST_ID__&ts=__TS__&reqtime=__ET__&referer=__CALLBACK_EXT_INFO__&userAgent=__UA__';
        issueAccount.issue_tv_url = 'https://tracking.aiseeking.com/tracking/v1/quick/view?appid=' + this.formData.app_id + '&apptype=' + this.formData.app_type + '&cid=' + this.formData.channel_id + '&csid=' + issueAccount.channel_slot_id + '&target=alipay&os=__OS__&ip=__IP__&imei=__IMEI__&oaid=__OAID_MD5__&model=__IDFA_MD5__&advertiserid=__PRINCIPAL_ID__&adid=__GROUP_ID__&creativeid=__AD_ID__&resolution=__CID__&rtaexp=__CAID__&androidid=__OPENID__&reqid=__REQUEST_ID__&ts=__TS__&reqtime=__ET__&referer=__CALLBACK_EXT_INFO__&userAgent=__UA__';
      } else if(this.formData.issue_platform=='baidu') {
        target = 'baidu';
        sip = 'bu';
        issueAccount.issue_tc_url = 'https://tracking.aiseeking.com/tracking/v1/quick/click?appid=' + this.formData.app_id + '&apptype=' + this.formData.app_type + '&cid=' + this.formData.channel_id + '&csid=' + issueAccount.channel_slot_id + '&target=baidu&callType=v2&referer=' + this.formData.baidu_api_akey + '&os=__OS__&resolution={{SIZE}}&oaidplain=__OAID__&oaid=__OAID_MD5__&imei=__IMEI_MD5__&ip=__IP__&userAgent=__UA__&androidid=__ANDROID_ID__&advertiserid=__USER_ID__&adid=__PLAN_ID__&creativeid=__IDEA_ID__&reqid=__CLICK_ID__&rtaexp=__EXT_INFO__&ts=__TS__';
        issueAccount.issue_tv_url = 'https://tracking.aiseeking.com/tracking/v1/quick/view?appid=' + this.formData.app_id + '&apptype=' + this.formData.app_type + '&cid=' + this.formData.channel_id + '&csid=' + issueAccount.channel_slot_id + '&target=baidu&callType=v2&referer=' + this.formData.baidu_api_akey + '&os=__OS__&resolution={{SIZE}}&oaidplain=__OAID__&oaid=__OAID_MD5__&imei=__IMEI_MD5__&ip=__IP__&userAgent=__UA__&androidid=__ANDROID_ID__&advertiserid=__USER_ID__&adid=__PLAN_ID__&creativeid=__IDEA_ID__&reqid=__CLICK_ID__&rtaexp=__EXT_INFO__&ts=__TS__';
      } else if(this.formData.issue_platform=='uc') {
        target = 'uc';
        sip = 'uc';
        issueAccount.issue_tc_url = 'https://tracking.aiseeking.com/tracking/v1/quick/click?appid=' + this.formData.app_id + '&apptype=' + this.formData.app_type + '&cid=' + this.formData.channel_id + '&csid=' + issueAccount.channel_slot_id + '&target=uc&advertiserid={ACID}&adid={AID}&creativeid={CID}&os={OS_ID}&model={MODEL1}&ip={IP}&oaid={OAID_SUM}&oaidplain={OAID}&imei={IMEI_SUM}&net={IMEI_SUM1}&referer={CALLBACK_URL}&userAgent={UA}&ts={UX_TS}';
        issueAccount.issue_tv_url = 'https://tracking.aiseeking.com/tracking/v1/quick/view?appid=' + this.formData.app_id + '&apptype=' + this.formData.app_type + '&cid=' + this.formData.channel_id + '&csid=' + issueAccount.channel_slot_id + '&target=uc&advertiserid={ACID}&adid={AID}&creativeid={CID}&os={OS_ID}&model={MODEL1}&ip={IP}&oaid={OAID_SUM}&oaidplain={OAID}&imei={IMEI_SUM}&net={IMEI_SUM1}&referer={CALLBACK_URL}&userAgent={UA}&ts={UX_TS}';
      } else if(this.formData.issue_platform=='wifi') {
        target = 'wifi';
        sip = 'wf';
        issueAccount.issue_tc_url = 'https://tracking.aiseeking.com/tracking/v1/quick/click?appid=' + this.formData.app_id + '&apptype=' + this.formData.app_type + '&cid=' + this.formData.channel_id + '&csid=' + issueAccount.channel_slot_id + '&target=wifi&advertiserid=__AID__&creativeid=__CID__&adid=__UID__&reqid=__SID__&reqtime=__STIME__&model=__MAC__&androidid=__ANDROID_ID__&imei=__IMEI__&os=__OS__&ip=__IP__&oaid=__HASH_OAID__&oaidplain=__OAID__&referer=__CALLBACK_URL__&userAgent=__UA__';
        issueAccount.issue_tv_url = 'https://tracking.aiseeking.com/tracking/v1/quick/view?appid=' + this.formData.app_id + '&apptype=' + this.formData.app_type + '&cid=' + this.formData.channel_id + '&csid=' + issueAccount.channel_slot_id + '&target=wifi&advertiserid=__AID__&creativeid=__CID__&adid=__UID__&reqid=__SID__&reqtime=__STIME__&model=__MAC__&androidid=__ANDROID_ID__&imei=__IMEI__&os=__OS__&ip=__IP__&oaid=__HASH_OAID__&oaidplain=__OAID__&referer=__CALLBACK_URL__&userAgent=__UA__';
      } else if(this.formData.issue_platform=='iqiyi') {
        target = 'iqiyi';
        sip = 'qy';
        issueAccount.issue_tc_url = 'https://tracking.aiseeking.com/tracking/v1/quick/click?appid=' + this.formData.app_id + '&apptype=' + this.formData.app_type + '&cid=' + this.formData.channel_id + '&csid=' + issueAccount.channel_slot_id + '&target=iqiyi&advertiserid=__ADVERTISER_ID__&creativeid=__CREATIVE_ID__&reqid=__IMPRESSS_ID__&androidid=__ANDROIDID__&os=__OS__&osVersion=__OS_VERSION__&model=__CELL_PHONE_MANUFACTURER__&net=__MAC__&ip=__IP__&oaid=__OAID_MD5__&oaidplain=__OAID__&imei=__IMEI__&referer=__CALLBACK_URL__&userAgent=__UA__&ts=__TS_MS__&rtaexp=__SIGN__';
        issueAccount.issue_tv_url = 'https://tracking.aiseeking.com/tracking/v1/quick/view?appid=' + this.formData.app_id + '&apptype=' + this.formData.app_type + '&cid=' + this.formData.channel_id + '&csid=' + issueAccount.channel_slot_id + '&target=iqiyi&advertiserid=__ADVERTISER_ID__&creativeid=__CREATIVE_ID__&reqid=__IMPRESSS_ID__&androidid=__ANDROIDID__&os=__OS__&osVersion=__OS_VERSION__&model=__CELL_PHONE_MANUFACTURER__&net=__MAC__&ip=__IP__&oaid=__OAID_MD5__&oaidplain=__OAID__&imei=__IMEI__&referer=__CALLBACK_URL__&userAgent=__UA__&ts=__TS_MS__&rtaexp=__SIGN__';
      } else if(this.formData.issue_platform=='weibo') {
        target = 'issue';
        sip = 'wb';
        issueAccount.issue_tc_url = 'https://tracking.aiseeking.com/tracking/v1/quick/click?appid=' + this.formData.app_id + '&apptype=' + this.formData.app_type + '&cid=' + this.formData.channel_id + '&csid=' + issueAccount.channel_slot_id + '&target=weibo&os=__OS__&osVersion=__OSVERSION__&ip=__IP__&net=__MAC1__&model=__MODEL__&lang=__SL__&imei=__IMEI__&oaid=__OAID_MD5__&androidid=__ANDROIDID__&advertiserid=__ADVERTISER_ID__&creativeid=__TSID__&adid=__AID__&adname=__AID_NAME__&referer=__CALLBACK_PARAM__&userAgent=__UA__&ts=__TS__';
        issueAccount.issue_tv_url = 'https://tracking.aiseeking.com/tracking/v1/quick/view?appid=' + this.formData.app_id + '&apptype=' + this.formData.app_type + '&cid=' + this.formData.channel_id + '&csid=' + issueAccount.channel_slot_id + '&target=weibo&os=__OS__&osVersion=__OSVERSION__&ip=__IP__&net=__MAC1__&model=__MODEL__&lang=__SL__&imei=__IMEI__&oaid=__OAID_MD5__&androidid=__ANDROIDID__&advertiserid=__ADVERTISER_ID__&creativeid=__TSID__&adid=__AID__&adname=__AID_NAME__&referer=__CALLBACK_PARAM__&userAgent=__UA__&ts=__TS__';
      } else {
        target = 'issue';
        sip = 'common';
        issueAccount.issue_tc_url = '';
        issueAccount.issue_tv_url = '';
      }

      // 针对不同应用类型生成链接
      if(QuickAppConfig[String(this.formData.app_id)]['type']=='app') {
        issueAccount.issue_h5_url = 'https://coscdn.' + QuickAppConfig[String(this.formData.app_id)]['domain'] + '.com' + QuickAppConfig[String(this.formData.app_id)]['path'] + QuickAppConfig[String(this.formData.app_id)]['name'] + '_' + target + '.html?sip=' + sip + '5&cid='+ this.formData.channel_id + '&csid=' + issueAccount.channel_slot_id + (this.formData.measure_id && this.formData.measure_id!='' ? '&mid=' + this.formData.measure_id + '&mtp=' + this.appraiseTemplets[this.formData.measure_id] : '') + (this.formData.book_id && this.formData.book_id!='' ? '&bid=' + this.formData.book_id + '&bnm=' + encodeURIComponent(this.bookNames[this.formData.book_id]) : '') + (this.formData.shortplay_id && this.formData.shortplay_id!='' ? '&vid=' + this.formData.shortplay_id : '') + (this.formData.cookbook_id && this.formData.cookbook_id!='' ? '&nid=' + this.formData.cookbook_id : '') + (this.formData.health_class_id!=undefined ? '&hcc=' + this.formData.health_class_id : '') + (this.formData.health_id && this.formData.health_id!='' ? '&hid=' + this.formData.health_id : '') + (this.formData.issue_company ? '&ic=' + this.formData.issue_company : '') + (this.formData.issue_bg_campaign ? '&il=' + this.formData.issue_bg_campaign : '') + (this.formData.issue_product ? '&io=' + this.formData.issue_product : '');
        issueAccount.issue_hap_url = 'hap://app/' + QuickAppConfig[String(this.formData.app_id)]['pkg'] + '/pages/start?sip=' + sip + '&cid=' + this.formData.channel_id + '&csid=' + this.formData.channel_slot_id + '&QUICK_APP_ST_CHANNEL=' + this.formData.channel_slot_id + (this.formData.measure_id && this.formData.measure_id!='' ? '&mid=' + this.formData.measure_id + '&mtp=' + this.appraiseTemplets[this.formData.measure_id] : '') + (this.formData.book_id && this.formData.book_id!='' ? '&bid=' + this.formData.book_id + '&bnm=' + encodeURIComponent(this.bookNames[this.formData.book_id]) : '') + (this.formData.shortplay_id && this.formData.shortplay_id!='' ? '&vid=' + this.formData.shortplay_id : '') + (this.formData.cookbook_id && this.formData.cookbook_id!='' ? '&nid=' + this.formData.cookbook_id : '') + (this.formData.health_class_id!=undefined ? '&hcc=' + this.formData.health_class_id : '') + (this.formData.health_id && this.formData.health_id!='' ? '&hid=' + this.formData.health_id : '');    
      } else if(QuickAppConfig[String(this.formData.app_id)]['type']=='game') {
        issueAccount.issue_h5_url = 'https://coscdn.' + QuickAppConfig[String(this.formData.app_id)]['domain'] + '.com' + QuickAppConfig[String(this.formData.app_id)]['path'] + QuickAppConfig[String(this.formData.app_id)]['name'] + '_' + target + '.html?sip=' + sip + '5&cid='+ this.formData.channel_id + '&csid=' + issueAccount.channel_slot_id + (this.formData.measure_id && this.formData.measure_id!='' ? '&mid=' + this.formData.measure_id + '&mtp=' + this.appraiseTemplets[this.formData.measure_id] : '') + (this.formData.book_id && this.formData.book_id!='' ? '&bid=' + this.formData.book_id + '&bnm=' + encodeURIComponent(this.bookNames[this.formData.book_id]) : '') + (this.formData.shortplay_id && this.formData.shortplay_id!='' ? '&vid=' + this.formData.shortplay_id : '') + (this.formData.cookbook_id && this.formData.cookbook_id!='' ? '&nid=' + this.formData.cookbook_id : '') + (this.formData.health_class_id!=undefined ? '&hcc=' + this.formData.health_class_id : '') + (this.formData.health_id && this.formData.health_id!='' ? '&hid=' + this.formData.health_id : '') + (this.formData.issue_company ? '&ic=' + this.formData.issue_company : '') + (this.formData.issue_bg_campaign ? '&il=' + this.formData.issue_bg_campaign : '') + (this.formData.issue_product ? '&io=' + this.formData.issue_product : '');
        let addition = {
          'sip': sip,
          'cid': this.formData.channel_id,
          'csid' : issueAccount.channel_slot_id,
        };
        if(this.formData.issue_platform=='oppo') {
          issueAccount.issue_hap_url = 'hap://game/' + QuickAppConfig[String(this.formData.app_id)]['pkg'] + '.nearme.gamecenter?userEntry=902&in_one_task=true&_GEOS_=' + encodeURIComponent(JSON.stringify(addition));
        } else {
          issueAccount.issue_hap_url = 'hap://app/' + QuickAppConfig[String(this.formData.app_id)]['pkg'] + '.nearme.gamecenter?userEntry=902&in_one_task=true&_GEOS_=' + encodeURIComponent(JSON.stringify(addition));
        }
      } else {
        issueAccount.issue_hap_url = '';
        issueAccount.issue_hap_url = '';
      }
      
      // 针对快手，hap连接增加参数
      if(this.formData.issue_platform=='kuaishou') {
        issueAccount.issue_hap_url = issueAccount.issue_hap_url + '&reqid=__CALLBACK__';
        issueAccount.issue_h5_url = issueAccount.issue_h5_url + '&reqid=__CALLBACK__';
      }

      // 针对趣头条，hap链接增加参数
      if(this.formData.issue_platform=='qtt') {
        issueAccount.issue_hap_url = issueAccount.issue_hap_url + '&callbackurl=__CALLBACK_URL__';
        issueAccount.issue_h5_url = issueAccount.issue_h5_url + '&callbackurl=__CALLBACK_URL__';
      }
      
      // 针对vivo，hap链接增加参数
      if(this.formData.issue_platform=='vivo') {
        issueAccount.issue_hap_url = issueAccount.issue_hap_url + '&reqid=__REQUESTID__';
      }

      // 针对iqiyi，链接增加参数
      if(this.formData.issue_platform=='iqiyi') {
        issueAccount.issue_hap_url = issueAccount.issue_hap_url + '&reqid=__IMPRESSS_ID__';
        issueAccount.issue_h5_url = issueAccount.issue_h5_url + '&reqid=__IMPRESSS_ID__';
      }

      // 针对OPPO平台，H5链接增加参数
      if(this.formData.issue_platform=='oppo') {
        issueAccount.issue_h5_url = issueAccount.issue_h5_url + '&ownerId=' + issueAccount.issue_account;
      }

      // 针对头条，链接增加reqid参数
      if(this.formData.issue_platform=='toutiao') {
        issueAccount.issue_h5_url = issueAccount.issue_h5_url + '&reqid=__CLICKID__';
      }
    },
    
    // 保存
    async submitForm(form) {
      // 验证表单数据
      this.$refs[form].validate((valid) => {
        if (valid) {
          // 显示页面加载
          const loading = this.$loading({
            lock: true,
            text: 'Processing ......',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)',
            target: '.box'
          });
          // 设置投放时间
          this.formData.issue_time = getCurrDateTime();
          // 广告场景空字符串处理
          this.formData.issue_ad_scene = this.formData.issue_ad_scene!='' ? this.formData.issue_ad_scene : null;
          if(this.formData.issue_ad_scene!=null) {
            this.formData.issue_ad_bidbase = null;
          }
          this.formData.issue_ad_bidbase = this.formData.issue_ad_bidbase!='' ? this.formData.issue_ad_bidbase : null;
          // 如果用户没有授权权限，自己创建的发布对象需要给自己授权
          if(this.operator && this.operator.permissions['10100500'] && this.operator.permissions['10100500'].indexOf('.authorize.')!=-1) {
            this.authorizeOperators.push({operator_id: this.operator.operatorId});
          }
          // 保存授权操作员集合
          if(this.authorizeOperators && this.authorizeOperators.length > 0) {
            let operatorIds = [];
            this.authorizeOperators.forEach(function(operator) {
              operatorIds.push(operator.operator_id);
            });
            this.formData.authorized_operators = operatorIds.join(',');
          }
          console.log(this.formData);
          // 调用新增接口
          this.$api.apiQuickAppIssueBatchAdd(this.formData).then (res => {
            if (res.result === 1) {
              // 请求成功
              this.$message("批量新增快应用投放成功", "success");
              // 调用刷新广告资源
              this.refreshAdResources(this.formData.app_id, this.formData.app_type);
              // 回退
              // this.$router.push('/running/luckystat/issue/index');
              // 设置保存按钮无效
              this.hasSavedAppIssue = true;
            } else {
              this.$message(res.message, "warning");
            }
          }).finally(() => {
            // 关闭加载
            loading.close();
          });
        }
      });
    },

    // 刷新应用线上广告资源
    async refreshAdResources(appId, appType) {
      // 请求刷新
      let params = new Object();
      params['appId'] = appId;
      params['appType'] = appType;
      this.$api.apiRefreshAdResources(params);
    },

    // 下载
    async onDownload() {
      if(!this.formData.issue_accounts || this.formData.issue_accounts.length <= 0 || !this.formData.issue_accounts[0].issue_h5_url) {
        // 请求成功
        this.$message("未生成有效链接，暂时无法下载", "warning");
        return;
      }
      // 发送请求到后端 API
      axios({
        url: api + '/running/luckystat/appissue/download',
        method: 'POST',
        data: this.formData.issue_accounts,
        responseType: 'blob', // 关键：设置响应类型为 blob
      })
      .then(response => {
        // 创建一个 URL 对象指向 Blob 数据
        const url = window.URL.createObjectURL(new Blob([response.data]));
        // 创建一个 <a> 元素用于下载
        const link = document.createElement('a');
        link.href = url;
        link.download = '应用批量发布_渠道(' + this.formData.channel_id + ')_渠道号(' + this.formData.issue_accounts[0].channel_slot_id + '-' + this.formData.issue_accounts[this.formData.issue_accounts.length - 1].channel_slot_id + ').xlsx';
        
        // 模拟点击下载
        document.body.appendChild(link);
        link.click();
      
        // 清理
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      })
      .catch(error => {
        console.error('下载失败', error);
        // 显示错误信息
        this.$message("下载失败", "warning");
      });
    },

    // 返回
    async onBack() {
      this.$router.push('/running/luckystat/issue/index');
    },

    /**
     * 员工授权操作相关方法
     */ 

    // 初始化操作员
    async initOperators() {
      // 清空当前渠道
      this.availableOperators = [];
      // 调用接口
      let res = await this.$api.apiCommonOperators();
      // 保存结果
      this.availableOperators = res.content;
    },

    // 移除授权员工
    removeAuthorizeOperator(operator) {
      this.authorizeOperators.splice(this.authorizeOperators.indexOf(operator), 1);
    },

    // 显示选择操作员下拉框
    showSelectOperator() {
      this.selectedOperatorId = null;
      this.selectOperatorVisible = true;
    },

    // 选中一个操作员
    onSelectedOperator(operatorId) {
      // 验证选择有效性
      if(!operatorId) {
        return;
      }
      // 遍历可选操作员，定位到目标操作员
      let selectedOperator = null;
      this.availableOperators.forEach(function(operator) {
        if(operatorId==operator.operator_id) {
          selectedOperator = operator;
          return;
        }
      });
      // 遍历已授权操作员，如果重复不添加，如果不重复添加
      let repeated = false;
      this.authorizeOperators.forEach(function(operator) {
        if(selectedOperator.operator_id==operator.operator_id) {
          repeated = true;
          return;
        }
      });
      if(!repeated) {
        this.authorizeOperators.push(selectedOperator);
      }
      // 隐藏操作员选择框
      this.selectOperatorVisible = false;
    },
  },
};
</script>

<style lang='scss' scoped>
.box {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  flex-wrap: nowrap;
  align-items: center;
  overflow: auto;
}
.path {
  margin: 10px 5px 0px 15px;
  padding: 0px;
  width: 100%;
  height: 20px;
  color: rgb(6, 6, 31);
  font-size: 1rem;
  display: flex;
  justify-content: flex-start;
  flex-wrap: nowrap;
  flex-direction: row;
  align-items: center;
}
.path_img {
  margin-right: 5px;
  height: 15px;
  width: 15px;
}
.path_txt {
  width: 100%;
  height: 20px;
  text-align: left;
}
.work {
  margin: 10px 5px 10px 5px;
  padding: 10px 0px 20px 0px;
  width: 98%;
  height: calc(100% - 20px);
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  flex-wrap: wrap;
  background: #fff;
  border-radius: 9px;
  align-items: center;
}
.work_form {
  width: 100%;
  height: auto;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}
.el-form-item {
  margin: 20px 5px 0px 15px;
  width: 96%;
  min-height: 38px;
  height: auto;
}
.el-input {
  width: 300px;
}
.el-select {
  width: 300px;
}
.el-button {
  width: 100px;
}
</style>